import styled from 'styled-components';

import DocumentsList from './DocumentsList';

export default styled(DocumentsList)`
  .documents-list {
    margin-bottom: 4rem;

    &__header {
      background-color: transparent;

      &:after {
        display: none;
      }

      .documents-list__header-row {
        background-color: transparent;

        &:hover {
          background-color: transparent;
        }
      }
    }

    &__row {
      color: var(--grey900);

      &:hover {
        background-color: var(--primary100);
        cursor: pointer;
      }

      &--inactive {
        background-color: var(--grey100);
      }
    }

    &__cell {
      &-name {
        color: var(--grey700);
        font-weight: bold;
        word-break: break-word;
      }

      &-type {
        font-weight: 500;
      }

      &-status {
        white-space: nowrap;
      }
      &-actions {
        align-items: center;
        display: flex;
      }
    }

    &__icon-button {
      padding: 0;
      margin: 0 0.8rem;
      svg {
        height: 16px;
        width: 16px;
      }
    }

    &__icon path {
      &:hover {
        fill: var(--colorPrimary900);
      }
    }

    &__no-docs {
      text-align: center;
    }

    &__profile-label {
      margin-bottom: 0.8rem;
    }

    &__profile-selector {
      margin-bottom: 1rem;
      &:hover {
        cursor: pointer;
      }
    }

    &__title-row {
      display: flex;
      justify-content: space-between;
    }

    &__profile-container {
      display: flex;
      flex-direction: column;
      width: 50%;
    }

    &__copy-landing {
      width: 100%;
      display: flex;
      margin-top: 2.5rem;
    }
  }
`;
